import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { ScopeControllerService } from '../services/scope-controller.service';

export const scopeGuard: CanMatchFn = () => {
  const controller = inject(ScopeControllerService);

  return controller.loadScope().pipe(
    map(() => true),
    catchError(() => of(true)),
  );
};
